const playVidFile = () => {

	function playPauseMedia(video) {
		if(video.paused) {
			video.play();
		} else {
			video.pause();
		}
	}

	document.addEventListener('click', (e) => {
		if(e.target.classList.contains('img-placeholder--file')) {
			const container = e.target.parentNode;
			const video = container.querySelector('video');
			if(!Object.is(video,null)) {
				playPauseMedia(video);
				container.classList.add("open");
				video.parentNode.classList.add("open");
			}
		} else if(e.target.classList.contains('img-placeholder--embed')) {
			const container = e.target.parentNode;
			const iframe = container.querySelector('iframe');
			if(!Object.is(iframe,null)) {
				let src = iframe.getAttribute('src');
				src = src.includes('autoplay=0&mute=0') ? src.replace(/autoplay=0&mute=0/i, 'autoplay=1&mute=1') : src += '&autoplay=1';
				iframe.setAttribute('src', src );
				container.classList.add("open");
				iframe.parentNode.classList.add("open");
			}
		}
	})
};

document.addEventListener("DOMContentLoaded",function() {
	playVidFile();
})

export { playVidFile }



// WEBPACK FOOTER //
// ./scripts/modules/_play-video.js